import BaseModel from './BaseModel'

export default class contactpersonEmailaddress extends BaseModel {
  static entity = 'contactpersons_emailaddresses'

  static primaryKey = ['contactperson_id', 'emailaddress_id']

  static fields() {
    return {
      contactperson_id: this.attr(null),
      emailaddress_id: this.attr(null),
    }
  }

  static methodConf = {
    methods: {
      $delete: {
        name: 'delete',
        http: {
          url: '/:contactperson_id/:emailaddress_id/',
          method: 'delete',
        },
      },
    },
  }
}
